const ORGANIZATION_COLLECTION = "organizations";

const processDoc = (doc) => {
  return { id: doc.id, ...doc.data() };
};

function OrganizationMixin(firebase, logger) {
  return {
    /**
     * Finds an organization by its ID.
     *
     * @param {string} id - The ID of the organization.
     * @returns The organization data, or null if the organization was not found.
     */
    async findOrganizationById(id) {
      const snapshot = await this.collection(ORGANIZATION_COLLECTION).doc(id).get();

      if (!snapshot.exists) {
        return null;
      }

      return processDoc(snapshot);
    },

    /**
     * Finds all organizations in the database.
     *
     * @returns An array of all organizations in the database.
     */
    async findAllOrganizations() {
      const snapshot = await this.collection(ORGANIZATION_COLLECTION).get();
      return snapshot.docs.map(processDoc);
    },

    addOrgaLog(orgaId, data) {
      logger.debug("FirebaseController:addOrgaLog", "called", {
        orgaId,
        data
      });

      data.orgaId = orgaId;

      return new Promise((fullfil, reject) => {
        this.collection("orga_logs_flat")
          .add(data)
          .then((result) => fullfil({ id: result && result.ref && result.ref.id }))
          .catch(reject);
      });
    },

    /**
     * Fetches the names of all active organizations from the database.
     * @param {string} fieldName - The name of the field to fetch the value of.
     * @returns An array of values of the field from all organizations.
     */
    getOrganizationsValue(fieldName) {
      return new Promise((resolve, reject) => {
        const organizationNames = [];
        this.collection(ORGANIZATION_COLLECTION)
          .select(fieldName)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              organizationNames.push(doc.data().name);
            });
            resolve(organizationNames);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getShowCreativeTableOrganizations() {
      return new Promise((resolve, reject) => {
        this.collection(ORGANIZATION_COLLECTION)
          .where("showCreativeTable", "==", true)
          .get()
          .then((querySnapshot) => {
            const organizations = [];
            querySnapshot.forEach((doc) => {
              organizations.push({ id: doc.id, ...doc.data() });
            });
            resolve(organizations);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async getOrganizationsWithPrepaidBalance() {
      const snapshots = await this.collection(ORGANIZATION_COLLECTION).get();

      const organizations = [];
      snapshots.forEach((doc) => {
        const data = doc.data();
        const prepaidBalance = parseFloat(data.prepaidBalance);
        if (data.prepaidBalance !== undefined && prepaidBalance > 0) {
          organizations.push({
            id: doc.id,
            ...data,
            prepaidBalance: parseFloat(data.prepaidBalance)
          });
        }
      });

      return organizations;
    }
  };
}

module.exports = OrganizationMixin;
